import { BigNumberish, BrowserProvider, Contract, Eip1193Provider, JsonRpcSigner } from 'ethers';
import { create } from 'zustand';
import { usdt_address } from '../web3/config';
import { IUserPub } from '@coimbra-its/api.sdbn.wallet';
import { produce } from 'immer';



export interface ISunConnectedWallet {
    walletProvider: Eip1193Provider,
    address: `0x${string}`,
    chainId: number,
    ethersProvider: BrowserProvider,
    signer: JsonRpcSigner,

    TokenContract: Contract,
    Token2PlusContract: Contract,
    USDTContract: Contract,
    //SaleContract: Contract,
    PayoutContractSDBN2: Contract,
    PayoutContractSDBN2Plus: Contract,
}


export interface SunState {
    connectedWallet: ISunConnectedWallet | null,
    walletDisconnected: () => void,
    walletConnected: (sunWalletProps: ISunConnectedWallet) => void,
    user : IUserPub | null;
    setUser : (v : IUserPub | null) => void;

}

export const useSunStore = create<SunState>()(
    (set, get) => ({

        connectedWallet: null,
        walletDisconnected: () => set(state => ({
            connectedWallet: null,
            initialRequest: false,
        })),
        walletConnected: (sunWalletProps) => set(state => ({
            connectedWallet: sunWalletProps,
            initialRequest: false,
        })),

        user: null,
        setUser : (v : IUserPub|null) => set(produce(state => { state.user = v }))

    }),
)